import script from "./TaxesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxesModal.vue?vue&type=script&setup=true&lang=js"

import "./TaxesModal.vue?vue&type=style&index=0&id=362a3144&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-362a3144"]])

export default __exports__